import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2", // Tailwind's blue-500 equivalent
    },
    secondary: {
      main: "#dc004e", // Tailwind's red-500 equivalent
    },
  },
  typography: {
    fontFamily: "Roboto, Arial, sans-serif",
  },
});

export default theme;
